const DefaultGalleryData = {
  name: "",
  gallery_type: "grid",
  grid_columns: '3',
  column_spacing: '10',
  mapper_order: "",
  mappers: [],
}

export default DefaultGalleryData
